import React, { useMemo } from 'react';
import parse, { DOMNode } from 'html-react-parser';
import { ElementType } from 'domelementtype';
import {
  sanitizeAndParseConfigLink,
  unescapeConfigString,
  stripBackslashesAndQuotes,
} from '../../common/utils';

export interface CustomHTMLProps {
  text: string;
  additionalClass?: string;
}

export const CustomHTML = ({ text, additionalClass = '' }: CustomHTMLProps) => {
  const parsedText = useMemo(() => {
    if (!text) {
      return;
    }
    return parse(text, {
      replace: (domNode: DOMNode) => {
        if (domNode.type === ElementType.Tag) {
          if (domNode.name === 'a') {
            const sanitizedLink = sanitizeAndParseConfigLink(domNode);
            if (!sanitizedLink.href) {
              return domNode;
            }
            return (
              <a
                href={sanitizedLink.href}
                target={sanitizedLink.target}
                rel={sanitizedLink.referrer}
                className={['accessible-link-text', additionalClass]
                  .filter((c) => c !== null)
                  .join(' ')}
              >
                {(domNode.children[0] as unknown as any).data}
              </a>
            );
          } else if (domNode.name === 'div') {
            let role = domNode.attribs?.role;
            if (role) {
              role = stripBackslashesAndQuotes(role) || '';
            }
            if (role === 'table') {
              domNode.attribs.className = `explanation-table ${additionalClass}`;
            } else if (role === 'table-header') {
              domNode.attribs.className = `explanation-table-header ${additionalClass}`;
            } else {
              domNode.attribs.className = `${additionalClass}`;
            }
            return domNode;
          }
        } else if (domNode.type === ElementType.Text) {
          domNode.data = unescapeConfigString(domNode.data);
        }
        return domNode;
      },
    });
  }, [text, additionalClass]);

  return <>{parsedText}</>;
};

export const constructMarkup = (text: string, additionalLinkClass?: string) => {
  return (
    <CustomHTML
      text={text}
      additionalClass={additionalLinkClass}
    />
  );
};
